import authHeader from "@/Api/AuthHeader";
import axios from "axios";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  actions: {
    async updatePassword(data) {
      return await axios.post(URL_API + "update_password", data, {
        headers: authHeader(),
      });
    },

    async firstLoginUpdatePassword(data) {
      return await axios.post(URL_API + "firstLoginUpdatePassword", data, {
        headers: authHeader(),
      });
    },
  },
};
